import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: "dashboard",
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  constructor(private router: Router,
  ) { }

  sourceUrl: string;
  encodedUrl: string;
  decodedUrl: string;

  async ngOnInit() {

  }
}
